
export const SAVE_PREFIX = "spellmasons-save-";